export const REALTIME_TRIPS_REQUEST = "REALTIME_TRIPS_REQUEST";
export const REALTIME_TRIPS_SUCCESS = "REALTIME_TRIPS_SUCCESS";
export const REALTIME_TRIPS_FAIL= "REALTIME_TRIPS_FAIL";
export const REALTIME_TRIPS_RESET= "REALTIME_TRIPS_RESET";

export const REALTIME_SPEED_REQUEST = "REALTIME_SPEED_REQUEST";
export const REALTIME_SPEED_SUCCESS = "REALTIME_SPEED_SUCCESS";
export const REALTIME_SPEED_FAIL= "REALTIME_SPEED_FAIL";
export const REALTIME_SPEED_RESET= "REALTIME_SPEED_RESET";